import qs from 'qs'

import {get, monolithGet} from './fetch'
import services from '../config/services'
import {camelCaseObjectKeys, onStatus, shimJson} from './helpers'

/**
 * Fetches a product set given a product ID or product slug.
 * @param productIdentifier {String|Number} Product ID or product slug
 */
export const getProductSet = (productIdentifier) =>
  get(`${services.PRODUCT_SERVICE_URL}/shop/product-sets/${productIdentifier}`).then(
    onStatus({
      OK: shimJson(camelCaseObjectKeys),
    }),
  )

/**
 * Fetches list of recommended items given a product set ID.
 * @param productSetId {String} Product set ID
 */
export const getRecommendedItems = (productSetId) =>
  get(`${services.PRODUCT_SERVICE_URL}/shop/product-sets/${productSetId}/recommended-items`).then(
    onStatus({
      OK: shimJson(camelCaseObjectKeys),
    }),
  )

/**
 * Fetches list of sizes carries given a product set ID.
 * @param productSetId {String} Product set ID
 */
export const getProductSizes = (productSetId) =>
  monolithGet(`/v1/product-sets/${productSetId}/sizes-carried`).then(
    onStatus({
      OK: shimJson(camelCaseObjectKeys),
    }),
  )

export const getProductsByTags = ({sortQueryParam, tagsQueryParam}) => {
  const params = {
    tags: tagsQueryParam,
    sort: sortQueryParam,
    is_retired: 'False',
    is_published: 'True',
  }
  const queryString = qs.stringify(params, {addQueryPrefix: true})

  return get(`${services.PRODUCT_SERVICE_URL}/shop/product-sets${queryString}`).then(
    onStatus({
      OK: shimJson(camelCaseObjectKeys),
    }),
  )
}
